import React from 'react';
import { connect } from "react-redux";
import { Theme, Text, i18n, tokens, Services, localizationMaps } from '@simplybenefits/sb-ui-library';
import getOocPolicyNumber from '../../services/getOocPolicyNumber';

const styles = {
    content: {
        backgroundColor: Theme.colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: '40px 60px',
        position: 'relative',
        marginRight: 65
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
        marginBottom: 10
    },
    rowTightGap: {
        display: 'flex',
        flexDirection: 'row',
        gap: 4,
        marginBottom: 10
    },
    verticalColumn: (width) => ({
        display: 'flex',
        flexDirection: 'column',
        width
    }),
    sectionMargin: {
        marginTop: 40,
        marginBottom: 40
    },
    titleSpacing: {
        marginBottom: 10
    }
};

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const RowItem = ({ label, item, width }) => (
    <div style={styles.verticalColumn(width)}>
        <Text bold small>{ label }</Text>
        <Text light small>{ item }</Text>
    </div>
);

/**
 * 
 * @returns
 */
const Details = ({ user, coverage }) => {
    const {
        cert,
        groupNum,
        company,
        className,
        divisionName,
        firstname,
        lastname,
        parentFirstName,
        parentLastName,
        isDependent
    } = user;

    const carrier = localizationMaps.fromEnglish('carriers', coverage.outOfCountry.carrier) || 'Orion';
    const oocPolicyNo = getOocPolicyNumber(user, carrier);
    const showOocSection = coverage.outOfCountry.benefitActive === 1;
    const displayName = isDependent ? `${ parentFirstName } ${ parentLastName }` : `${ firstname } ${ lastname }`;

    return (
        <div style={styles.content}>
            <Text bold mediumLarge customStyle={styles.titleSpacing}>
                { i18n.t(tokens.labels.general) }
            </Text>

            <div style={styles.row}>
                <RowItem
                    label={i18n.t(tokens.labels.signup.certificateNumber)}
                    item={cert}
                    width={'27%'}
                />

                <RowItem
                    label={i18n.t(tokens.labels.primaryMemberName)}
                    item={displayName}
                    width={'27%'}
                />

                <RowItem
                    label={i18n.t(tokens.labels.infoModal.groupNumber)}
                    item={groupNum}
                    width={'20%'}
                />

                <RowItem
                    label={i18n.t(tokens.labels.groupName)}
                    item={company}
                    width={'20%'}
                />
            </div>

            <div style={styles.row}>
                <RowItem
                    label={i18n.t(tokens.labels.classesAndDivisions.className)}
                    item={className}
                    width={'27%'}
                />
                <RowItem
                    label={i18n.t(tokens.labels.classesAndDivisions.divisionName)}
                    item={divisionName}
                    width={'27%'}
                />
            </div>

            { showOocSection && (
                <div style={styles.sectionMargin}>
                    <Text bold mediumLarge customStyle={styles.titleSpacing}>
                        { i18n.t(tokens.titles.outOfCountry) }
                    </Text>

                    <Text bold medium>
                        { i18n.t(tokens.titles["emergency travel assist"]) }
                    </Text>

                    <div style={styles.rowTightGap}>
                        <Text light tiny>{ i18n.t(tokens.titles["24 7 medical"]) }</Text>
                        <Text light tiny>{ i18n.t(tokens.titles["please call within 24 hours"]) }</Text>
                    </div>

                    <div style={styles.row}>
                        <RowItem
                            label={i18n.t(tokens.titles["in canada or usa"])}
                            item={Services.constants.phoneNumbers[carrier].northAmerica}
                            width={'27%'}
                        />

                        <RowItem
                            label={i18n.t(tokens.titles.internationally)}
                            item={Services.constants.phoneNumbers[carrier].international}
                            width={'27%'}
                        />

                        {
                            oocPolicyNo && (
                                <RowItem
                                    label={i18n.t(tokens.titles["ooc policy no"])}
                                    item={oocPolicyNo}
                                    width={'20%'}
                                />
                            )
                        }

                        <RowItem
                            label={i18n.t(tokens.titles["ooc provider"])}
                            item={ carrier }
                            width={'20%'}
                        />
                    </div>
                </div>)
            }

            <Text bold mediumLarge customStyle={styles.titleSpacing}>
                { i18n.t(tokens.labels.simplyBenefitsContactDetails) }
            </Text>

            <div style={styles.row}>
                <RowItem
                    label={i18n.t(tokens.labels.phoneNumber)}
                    item={Services.constants.phoneNumberCanadaUSA}
                    width={'27%'}
                />
                <RowItem
                    label={i18n.t(tokens.labels.website)}
                    item={"www.simplybenefits.ca"}
                    width={'27%'}
                />
            </div>
        </div>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    user: state.user.meta,
    coverage: state.coverage.data
});

export default connect(mapStateToProps)(Details);